import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

import { Neutrals } from '../../color-palette/colors';
import { PROSE_MAX } from '../Screen/screenLayout';

export const rootSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 4, minInlineSize: 0 };

export const leadSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 1 };

export const sentLineSx: SystemStyleObject<Theme> = { color: Neutrals[700], maxInlineSize: PROSE_MAX, overflowWrap: 'anywhere' };

export const stressSx = (theme: Theme): SystemStyleObject<Theme> => ({
  color: Neutrals[900],
  fontWeight: theme.typography.highlight.fontWeight,
});

export const noteSx: SystemStyleObject<Theme> = { color: Neutrals[600], maxInlineSize: PROSE_MAX };


export const fillOnPhoneSx: SystemStyleObject<Theme> = { alignSelf: { xs: 'stretch', sm: 'flex-start' } };

export const haltedSx: SystemStyleObject<Theme> = { display: 'flex', flexDirection: 'column', gap: 3 };

export const startSx: SystemStyleObject<Theme> = { alignSelf: 'flex-start' };
